import { Identifiable, List, Task } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { mapError } from "../utils/mapError";

function moveTask(httpClient: HttpClient) {
  return (
    task: Identifiable<Task>,
    parentList: Identifiable<List>,
    alignDates: boolean,
  ) =>
    httpClient
      .sendHttpRequest<void>({
        endpoint: `/projects/moveElement`,
        method: HttpMethods.POST,
        data: {
          elementUuid: task.uuid,
          projectEntityType: "TASK",
          targetActivityUuid: parentList.uuid,
          conserveTime: !alignDates,
        },
      })
      .catch((e) => {
        return Promise.reject(
          mapError(e, {
            startDateOutOfBoundProject: "startDateOutOfBoundProject",
            startDateOutOfBound: "startDateOutOfBound",
            endDateOutOfBoundProject: "endDateOutOfBoundProject",
            endDateOutOfBound: "endDateOutOfBound",
          }),
        );
      });
}

export { moveTask };
